const CheckMark = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="12"
        fill="var(--header-toggle-checkmark-bg)"
      />
      <path
        d="M10 14.7799L7.22001 11.9999L6.27335 12.9399L10 16.6666L18 8.66656L17.06 7.72656L10 14.7799Z"
        fill="var(--bg-primary)"
      />
    </svg>
  );
};
export default CheckMark;
